import { defaultSchema } from 'rehype-sanitize'
import type { Schema } from 'hast-util-sanitize'

// Extends GitHub's default sanitization schema to keep allowing the `inline-img`
// class UiMarkdown adds when substituting `:icon_name:` tokens, and the `data:` URLs
// used for dynamic images such as the map.
export const sanitizeSchema: Schema = {
  ...defaultSchema,
  attributes: {
    ...defaultSchema.attributes,
    img: [...(defaultSchema.attributes?.img ?? []), ['className', 'inline-img']],
  },
  protocols: {
    ...defaultSchema.protocols,
    href: [...(defaultSchema.protocols?.href ?? []), 'data'],
    src: [...(defaultSchema.protocols?.src ?? []), 'data'],
  },
}
